// extracted by mini-css-extract-plugin
export default {"wrapper":"NoData_wrapper__AmvMg","noData":"NoData_noData__N+HfI","iconWrapper":"NoData_iconWrapper__t4rO1"};